import { createFileRoute } from '@tanstack/react-router';

import {
  handleLinkLogin,
  validateLinkLoginSearch,
} from '@/features/auth/services/link-login.service';
import { NotFoundPage } from '@/pages/not-found.page';

export const Route = createFileRoute('/$locale/$token')({
  validateSearch: validateLinkLoginSearch,
  beforeLoad: ({ params, search }) => {
    handleLinkLogin({
      token: params.token,
      locale: params.locale,
      redirectTo: search.redirectTo,
    });
  },
  component: NotFoundPage,
});
